import React from 'react'

export const CardTestimonial = ({image, title, description, name}) => (
  <div className="card">
    <div className="card-body">
      <div className='about-card'>
        <img className='about-icon' src={image} ></img>
        <div className="about-card-title ms-3">{title}</div>
      </div>
      <p className="card-text mt-3">{description}</p>
      <p className='card-testimonial-user'>{name}</p>
    </div>
  </div>
)

export default CardTestimonial
